import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-serviceConfig",
  "use": "icon-serviceConfig-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-serviceConfig\"><path d=\"M0 947.2h780.8V364.8H0v582.4z m243.2-832v96h684.8v537.6H1024V115.2H243.2z\" fill=\"#040000\" p-id=\"4239\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol